<template>
  <div class="page_box">
    <!--    {{ isSelectAll }}-->
    <!-- 左侧统计 -->
    <div class="left_total" v-if="isShowLeft">
      <el-checkbox
          v-if="isShowSelect"
          :style="{width: selectionWidth +'px !important',display: 'flex',justifyContent: 'center',alignItems: 'center'}"
          v-model="isSelectAll" :size="checkBoxSize" @change="selectAll"/>
      <div v-else
           :style="{width:(maxNumber>0?10:isShowPageSize? 26:16) +'px !important',display: 'flex',justifyContent: 'center',alignItems: 'center'}"></div>
      <div style="margin-left: -5px; font-size: 13px; color: #646464">
        <span v-if="maxNumber>0">{{ $t('common.group.email.computed') }} <span style="color: #5a9cf8">{{ total }}</span><span
            style="color: #b94e45">/{{ maxNumber }}</span> {{ $t('common.group.email') }}</span>
        <span style="font-size: 13px !important;" v-else>{{ $t('count.data', {count: total}) }}</span>
        <span v-if="isShowSelectItem" style="margin: 0px 4px">|</span>
        <span v-if="isShowSelectItem"
              style="font-size: 13px !important;">
          {{
            $t('count.check.data', {
              count: isSelectAll ? total : Array.isArray(multipleSelection)
                  ? multipleSelection.length
                  : typeof multipleSelection === 'object' && multipleSelection !== null
                      ? Object.keys(multipleSelection).length
                      : 0
            })
          }}
        </span>
      </div>
    </div>
    <slot name="select"></slot>
    <!-- 右侧设置 -->
    <div class="right_setting">
      <!-- 每页条数 -->
      <div v-if="isShowPageSize">
        <el-select
            v-model="pageSize"
            placeholder="Select"
            size="default"
            class="page_com"
            style="width: 40px;"
            @change="onSizeChange"
        >
          <el-option
              v-for="item in options"
              :key="item"
              :label="item + $t('pagination.tiao')"
              :value="item"
          />
        </el-select>
        <span style="color: #bcbec2; font-size: 13px; margin: 0 10px">{{ $t('pagination.pagesize') }}</span>
      </div>

      <!-- 页码控制 -->
      <div class="page">
        <el-button class="btn" :disabled="currentPage <= 1" @click="goFirstPage">
          <img src="./img/left.svg" style="width: 10px; height: 10px"/>
        </el-button>

        <el-input-number
            size="small"
            v-model="currentPage"
            :min="1"
            :max="pageCount"
            @change="onPageChange"
        >
          <template #decrease-icon>
            <el-icon>
              <CaretLeft/>
            </el-icon>
          </template>
          <template #increase-icon>
            <el-icon>
              <CaretRight/>
            </el-icon>
          </template>
          <template #suffix>
            <span>/{{ pageCount }}{{ $t('pagination.ye') }}</span>
          </template>
        </el-input-number>

        <el-button class="btn" :disabled="currentPage >= pageCount" @click="goLastPage">
          <img src="./img/right.svg" style="width: 10px; height: 10px"/>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, watch} from "vue";
import {CaretLeft, CaretRight} from "@element-plus/icons-vue";
import {useStore} from "vuex";

const store = useStore()
const props = defineProps({
  total: {
    type: Number,
    default: 0,
  },
  selected: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: Number,
    default: 1,
  },
  pageSizeValue: {
    type: Number,
    default: 10,
  },
  multipleSelection: {
    type: Array,
    default: () => []
  },
  isShowSelect: {
    type: Boolean,
    default: false
  },
  selectionWidth: {
    type: Number,
    default: 40
  },
  checkBoxSize: {
    type: String,
    default: 'default'
  },
  isShowLeft: {
    type: Boolean,
    default: true
  },
  isShowPageSize: {
    type: Boolean,
    default: true,
  },
  isShowSelectItem: {
    type: Boolean,
    default: true
  },
  maxNumber: {
    type: Number,
    default: 0,
  }
});

const emit = defineEmits(["update:modelValue", "update:pageSizeValue", "change"]);
const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isSelectAll = ref(false);
const currentPage = ref(props.modelValue);
const pageSize = ref(props.pageSizeValue);

const options = [10, 20, 30, 50];
const selectAll = (val) => {
  console.log(val, 'isSelectAll')
  val ? checkAllItem() : unCheckAllItem()
  emit("getSelect", val)
}

const checkAllItem = () => {
  emit("checkAllItemPage")
}

const unCheckAllItem = () => {
  emit("unCheckAllItemPage")
}

// 总页数计算
const pageCount = computed(() =>
    Math.max(Math.ceil(props.total / pageSize.value), 1)
);

// 监听分页输入框
watch(() => props.modelValue, (val) => {
  currentPage.value = val;
});

watch(() => props.pageSizeValue, (val) => {
  pageSize.value = val;
});

const onPageChange = (val) => {
  emit("update:modelValue", val);
  emit("change", {pageNo: val, pageSize: pageSize.value});
};

const onSizeChange = (val) => {
  currentPage.value = 1;
  emit("update:pageSizeValue", val);
  emit("update:modelValue", 1);
  emit("change", {pageNo: 1, pageSize: val});
};

const goPrev = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    onPageChange(currentPage.value);
  }
};

const goNext = () => {
  if (currentPage.value < pageCount.value) {
    currentPage.value++;
    onPageChange(currentPage.value);
  }
};


const goFirstPage = () => {
  if (currentPage.value !== 1) {
    currentPage.value = 1;
    onPageChange(1);
  }
};

const goLastPage = () => {
  if (currentPage.value !== pageCount.value) {
    currentPage.value = pageCount.value;
    onPageChange(pageCount.value);
  }
};
const setIsSelectAll = (payload) => {
  isSelectAll.value = payload
}

defineExpose({
  isSelectAll,
  setIsSelectAll,
})
</script>

<style lang="less" scoped>
.page_box {
  width: 100%;
  height: 40px;
  display: flex;
  //background: red;
  justify-content: space-between;
  align-items: center;

  .left_total {
    display: flex;
    align-items: center;
  }

  .right_setting {
    display: flex;
    align-items: center;
  }

  .btn {
    padding: 0 !important;
    height: 24px;
    width: 25px;
    border-radius: 0 !important;
    background: #f5f7fa !important;
  }
}

:deep(.el-input__wrapper) {
  border-radius: 0 !important;
  width: 100% !important;
}

.right_setting {
  :deep(.el-select) {
    width: 100px !important;
  }
}

:deep(.el-input__inner) {
  font-size: 13px !important;
  width: max-content !important;
}

:deep(.el-input__suffix-inner) {
  font-size: 13px !important;
}

.page_com {
  :deep(.el-select__wrapper) {
    height: 24px !important;
    min-height: 24px !important;
  }
}

:deep(.el-input-number--small) {
  width: 150px !important;
}

:deep(.el-input__suffix) {
  width: 50px !important;
}
</style>